import { type ZodError } from 'zod';

type ZodErrorMessageProps = {
  readonly children?: (message: string) => JSX.Element;
  /**
   * The Zod validation Error
   */
  readonly error: null | ZodError;
  /**
   * The name of the field you want to check against path.
   */
  readonly path: RegExp | string;
};

export const ZodErrorMessage = ({
  children,
  error,
  path,
}: ZodErrorMessageProps) => {
  const validationError = error?.errors?.length
    ? error?.errors.find((issue) => {
        if (issue.path) {
          if (typeof path === 'string') {
            return issue.path.join('.') === path;
          }

          return path.test(issue.path.join('.'));
        }

        return false;
      })
    : error;

  if (validationError) {
    if (children) return children(validationError.message);

    return <>{validationError.message}</>;
  }

  return null;
};
